import React, { Component } from 'react'
import PurchaseButton from '../../Global_Layouts/PurchaseButton/PurchaseButton'
import Product_content from '../../Layouts/Layouts_product/Product_content/Product_content'
import Product_data from '../../Layouts/Layouts_product/Product_data/Product_data'
import Product_imgs from '../../Layouts/Layouts_product/Product_imgs/Product_imgs'
import PackSelector from '../../Layouts/Layouts_PurchaseForm/PackSelector/PackSelector'
import { MagneticUnion_ProductData } from '../../ProductsData/MagneticUnion'
import { Squid_ProductData } from '../../ProductsData/Squid'
import './Product.css'
import { onlyOnePurchaseButtonVisible } from './Scripts/onlyOnePurchaseButtonVisible'
import SellsAlerts from '../SoldOutProduct/SellsAlerts'
import Product_size_match from '../../Layouts/Layouts_product/Product_size_match/Product_size_match'
import VideoOver from '../../Layouts/Layouts_product/Product_video/Product_video'
import Product_cross_sell from '../../Layouts/Layouts_product/Product_cross_sell/Product_cross_sell'
import { getProductsById } from '../../GetProducts/getCollectionProducts'
import { ProductCard } from '../Collection/Collection'
import { isValidHttpsURL } from '../../Helpers/isValidHttpsURL'
import LoaderPage from '../../Global_Layouts/LoaderPage/LoaderPage'

let unsubscribeFromProducts = null

export default class Product extends Component {

  state={
    modalIsOpen: false,
    ProductData: {},
    // ProductData: this.props.product_data_for_sell,
    selectedPackId: "0",
    selectedPackData: {},
    // selectedPackData: this.props.product_data_for_sell.comodin_packs[0],
    selectedVariants: [],
    shoppingMoreThanOne: false,
  }

  componentDidMount=()=>{
    //1. Inicializa "selectedVariants" con los valores de index "0" de cada opcion de variante
    const {specific_product_id} = this.props
    if (specific_product_id) {
      this.getProductData()
    }
  }

  getProductData = () => {
    const {specific_product_id} = this.props
    if (unsubscribeFromProducts) {
      unsubscribeFromProducts()
    }
    unsubscribeFromProducts = getProductsById(this.props.db, [{product_id_for_sell: specific_product_id}], 
      (productObj)=>{
        this.setState({ProductData: productObj, selectedPackData: productObj.comodin_packs[0], selectedPackId: "0"})
        if (productObj.id) {
          this.props.selectProduct_Data(productObj)
          this.initializedSelectedVariantsArrayFunction(productObj.comodin_packs[0])
        }
      }
    );
  }

  componentWillUnmount=()=>{
    if (unsubscribeFromProducts) {
      unsubscribeFromProducts()
    }
  }

  componentDidUpdate=(prevProps, prevState)=>{
    const {ProductData, selectedPackData, selectedPackId} = this.state
    let goToshoppingOne = true
    // if(prevProps.product_data_for_sell.product_inside_id !== this.props.product_data_for_sell.product_inside_id){
    //   this.setState({
    //     ProductData: this.props.product_data_for_sell,
    //     selectedPackData: this.props.product_data_for_sell.comodin_packs[0],
    //   })
    //   setTimeout(() => {
    //     window.scrollTo({
    //       top: 0,       // Posición vertical (y)
    //       left: 0,      // Posición horizontal (x)
    //       behavior: 'smooth'  // Desplazamiento suave
    //     });
    //     goToshoppingOne = false
    //   }, 250);
    // }
    if(prevState.selectedPackData !== selectedPackData){
      this.initializedSelectedVariantsArrayFunction(selectedPackData)
      if(selectedPackId!=="0"){
        setTimeout(() => {
          this.setState({
            shoppingMoreThanOne: true
          })
        }, 1000);
      } else if(selectedPackId==="0"){
        this.setState({
          shoppingMoreThanOne: false
        })
        if (goToshoppingOne){
          // document.getElementById("shoppingOne").scrollIntoView()
        }
      }
    }

    if (prevProps.specific_product_id !== this.props.specific_product_id) {
      this.getProductData()
    }

  }

  initializedSelectedVariantsArrayFunction = (selectedPackData) => {
    const {ProductData} = this.state
    let initializedSelectedVariantsArray = []

    if(ProductData.productWithVariations==="SI"){
      ProductData.productOptions.map((variantData, index) => {
        selectedPackData.units.map(unit=>{
          //THIS SELECT THE FIRS OPTION ALWAYS let varData = this.getSelectedVariants({variant: variantData.values[0], value: "0"}, unit, index, true)
          
          // START THIS, SELECT A RANDON VALUE FROM activeIndices TO SET THE DEFAULT OPTION SELECTED
          let activeIndices = variantData.option_is_active.reduce((indices, isActive, i) => {
            if(isActive) indices.push(i);
            return indices;
          }, []);
          let randomIndex = activeIndices[Math.floor(Math.random() * activeIndices.length)];
          let varData = this.getSelectedVariants({variant: variantData.values[randomIndex], value: randomIndex.toString()}, unit, index, true);
          // END THIS, SELECT A RANDON VALUE FROM activeIndices TO SET THE DEFAULT OPTION SELECTED

          initializedSelectedVariantsArray[unit] = {
            ...initializedSelectedVariantsArray[unit],
            [varData.variant_key]: varData.variant_key_value,
            sku: varData.sku,
            variant_title: varData.variant_title,
            variation_index_calculated: varData.variation_index_calculated,
            variation_index_from_product_data: varData.variation_index_from_product_data,
          }
        })
      })
    } else {
      this.state.selectedPackData?.units.map(item=>{
        initializedSelectedVariantsArray.push({
          sku: ProductData.productVariations[0].variation_sku,
          variant_title: ProductData.productVariations[0].variation_title,
          variation_index_calculated: "",
          variation_index_from_product_data: "",
        })
      })
    }

    this.setState({
      selectedVariants: initializedSelectedVariantsArray
    })
  }

  getSelectedPackData = (e, newSelectedPackData) => {
    const {ProductData, selectedPackData} = this.state
    if(selectedPackData !== newSelectedPackData && newSelectedPackData!==undefined && newSelectedPackData!==null && newSelectedPackData!==""){
      this.setState({
        selectedPackId: e.target.id,
        selectedPackData: newSelectedPackData,
        selectedVariants: [],
      })
      // console.log("newSelectedPackData")
      // console.log(newSelectedPackData)
      // if(ProductData.productWithVariations==="SI" && selectedPackData!==newSelectedPackData){
      //   this.initializedSelectedVariantsArrayFunction(newSelectedPackData)
      // }
    }
  }

  getSelectedVariants = (e, unit, index, isInitialized, value) => {
    const {ProductData} = this.state
    //MODEL: selectedVariants: [{variant0:"", variant1:""},{variant0:"", variant1:""},{variant0:"", variant1:""}],
    //2. Actualiza el valor de la variante del "index" para la unidad "unit"
    if(ProductData.productWithVariations==="SI"){
      let newSelectedVariantObj = {
        ...this.state.selectedVariants[unit],
        variant_key: "variant"+index.toString(),
        ["variant"+index]: isInitialized===true? e.variant : value!==undefined && value!==null && value!==""? value.split("@")[0] : e.target.value.split("@")[0],
        ["option"+index]: index.toString(),
        ["value"+index]: isInitialized===true? e.value : value!==undefined && value!==null && value!==""? value.split("@")[1] : e.target.value.split("@")[1]
      }
      //2.1. Obtiene "sku" y "variation_title" con base en "option"+index" y ""value"+index" y "productOptions.length"
      let variation_index = ""
      for (let i = 0; i < ProductData.productOptions.length; i++) {
        let OP = newSelectedVariantObj["option"+i]!==undefined? newSelectedVariantObj["option"+i] : i
        let V = newSelectedVariantObj["value"+i]!==undefined? newSelectedVariantObj["value"+i] : "0"
        let content_to_add = "OP"+OP+"-"+"V"+V
        variation_index = variation_index + (i===0? content_to_add : ("/" + content_to_add))
      }
      let variationData = ProductData.productVariations.filter( variationData => variationData.variation_index === variation_index)[0]
      newSelectedVariantObj.sku = variationData.variation_sku
      newSelectedVariantObj.variant_title = variationData.variation_title
      newSelectedVariantObj.variation_index_calculated = variation_index
      newSelectedVariantObj.variation_index_from_product_data = variationData.variation_index
      newSelectedVariantObj.img_src = variationData.variation_img_src
      //3. Actualiza las variantes de la unidad "unit"
      if(isInitialized===true){
        return {
          variant_key: newSelectedVariantObj.variant_key,
          variant_key_value: newSelectedVariantObj[newSelectedVariantObj.variant_key],
          sku: newSelectedVariantObj.sku,
          variant_title: newSelectedVariantObj.variant_title,
          variation_index_calculated: newSelectedVariantObj.variation_index_calculated,
          variation_index_from_product_data: newSelectedVariantObj.variation_index_from_product_data,
        }
      } else {
        let newSelectedVariantsArray = [...this.state.selectedVariants]
        newSelectedVariantsArray[unit] = newSelectedVariantObj
        this.setState({
          selectedVariants: newSelectedVariantsArray
        })
      }
    } else {
      const selectedVariants = []
      this.state.selectedPackData?.units.map(item=>{
        selectedVariants.push({
          sku: ProductData.productVariations[0].variation_sku,
          variant_title: ProductData.productVariations[0].variation_title,
          variation_index_calculated: "",
          variation_index_from_product_data: "",
        })
      })
      this.setState({
        selectedVariants: selectedVariants
      })
    }
  }


  selectProduct = async (product) => {
    await this.props.selectProductFromCollection(product)
  }


  render() {

    const {ProductData, selectedPackId, selectedPackData, selectedVariants, shoppingMoreThanOne} = this.state
    const {readData, quantity, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code } = this.props
    const {product_data_for_sell, store_with_upsell, product_data_for_upsell } = this.props
    const {UTM_params, discount_code} = this.props
    const {resetAll, discount_value, setDiscountValue, setShowToast, min_qty_to_get_bulk_discount, free_shipping, shipping_cost, bulk_unit_discount, units, cart_items, add_to_cart, remove_from_cart} = this.props
    const {selectProductFromCollection, collection_products} = this.props
    const {specific_product_id} = this.props

    // if (!ProductData.id) {
    //   return null
    // }

    if (!ProductData.id) {
      return <LoaderPage/>
    }

    let aux_additional_comodin_imgs_src = []
    ProductData.additional_comodin_imgs_src.map(img=>{
      aux_additional_comodin_imgs_src.push(img.file_src)
    })

    
    return (
      <div className='Product'>
        
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-12 col-lg-6">
                    <Product_imgs specific_product_id={specific_product_id} ProductData={ProductData} shoppingMoreThanOne={shoppingMoreThanOne} selectedVariants={selectedVariants}/>
                </div>
                <div className="col-md-12 col-lg-6">
                    <div id='shoppingOne'></div>
                    <Product_data 
                      resetAll={resetAll}
                      discount_value={discount_value} 
                      setDiscountValue={setDiscountValue} 
                      // setShowToast={(boolean)=>setShowToast(boolean)} 
                      min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} 
                      free_shipping={free_shipping} 
                      shipping_cost={shipping_cost} 
                      bulk_unit_discount={bulk_unit_discount} 
                      units={units}
                      cart_items={cart_items}
                      add_to_cart={add_to_cart}
                      remove_from_cart={remove_from_cart}
                      
                      discount_code={discount_code} UTM_params={UTM_params} product_data_for_upsell={product_data_for_upsell} shoppingMoreThanOne={shoppingMoreThanOne}  readData={readData} selectedVariants={selectedVariants} getSelectedVariants={this.getSelectedVariants} ProductData={ProductData} getSelectedPackData={this.getSelectedPackData} selectedPackId={selectedPackId} selectedPackData={selectedPackData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code}
                    />

                    

                    {
                      ProductData.comodin_packs.length > 1 && (
                        <div className='Product_title'>Lleva más y paga menos</div>
                      )
                    }

                    <div style={{marginTop:"15px"}}>
                      <PackSelector shoppingMoreThanOne={shoppingMoreThanOne} hidePackOne={true} hideSummaryTable={true} selectedVariants={selectedVariants} getSelectedVariants={this.getSelectedVariants} ProductData={ProductData} getSelectedPackData={this.getSelectedPackData} selectedPackId={selectedPackId} selectedPackData={selectedPackData}/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 d-flex justify-content-center">
                    <Product_content  ProductData={ProductData}/>
                </div>
            </div>
            <div id='sticky_purchase_btn' style={{marginTop:cart_items.length > 0? "50px" : undefined, marginBottom:cart_items.length > 0? "100px" : undefined}} className={cart_items.length > 0? undefined : 'sticky-footer'}>
              <PurchaseButton
                useAddEventListener={true}
                resetAll={resetAll}
                discount_value={discount_value}
                setDiscountValue={setDiscountValue}
                // setShowToast={(boolean)=>setShowToast(boolean)} 
                min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} 
                free_shipping={free_shipping} 
                shipping_cost={shipping_cost} 
                bulk_unit_discount={bulk_unit_discount} 
                units={units} 
                from_cart={false} 
                cart_items={cart_items} 
                add_to_cart={add_to_cart} 
                remove_from_cart={remove_from_cart}
                
                discount_code={discount_code} UTM_params={UTM_params} product_data_for_upsell={product_data_for_upsell} selectedVariants={selectedVariants} getSelectedVariants={this.getSelectedVariants} ProductData={ProductData} getSelectedPackData={this.getSelectedPackData} selectedPackId={selectedPackId} selectedPackData={selectedPackData}  readData={readData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code} />
            </div>
            <div className='row'>
              {/* <Product_cross_sell current_product_data_for_sell={ProductData} change_product_data_for_sell={this.props.change_product_data_for_sell} products={this.props.storeData.products}/> */}
              {/* <Product_cross_sell current_product_data_for_sell={ProductData} products={this.props.storeData.products}/> */}
              
              {/* {
                collection_products.length > 0 && (
                  <h1 style={{marginTop:"100px"}}>Sugeridos para ti ✨</h1>
                )
              } */}
              
              {/* <div className='CollectionList'>
                {
                  collection_products.filter(product=>product.id !== ProductData.id).map(product=>
                    product.comodin_title && (
                      <div>
                        <ProductCard units={units} bulk_unit_discount={bulk_unit_discount} selectProduct={()=>this.selectProduct(product)} product={product} cart_items={cart_items} add_to_cart={add_to_cart} remove_from_cart={remove_from_cart}/>
                      </div>
                    )
                  )
                }
              </div> */}

            </div>
        </div>

        {
          isValidHttpsURL(ProductData.video_over_url) && (
            <VideoOver src={ProductData.video_over_url} />
          )
        }

        {/* <VideoOver src={"https://firebasestorage.googleapis.com/v0/b/demoda-inside.appspot.com/o/assets%2Feccos.mp4?alt=media&token=f93a42f4-def0-4ac9-9772-4caac5d08bf2"} /> */}

        <SellsAlerts gender={ProductData.gender} product_imgs={aux_additional_comodin_imgs_src}/>

      </div>
    )
  }
}
